import { useEffect, useState } from 'react';
import { usePrefersReducedMotion } from '../hooks/usePrefersReducedMotion';

export function SkillGlassTitle({
  title,
  index,
  fontSizePx,
  isActive,
  darkWhenIdle,
  isVisible,
  fromLeft,
  enterDelayMs = 0,
}) {
  const reducedMotion = usePrefersReducedMotion();
  const [motionDone, setMotionDone] = useState(false);
  const clipId = `skill-glass-clip-${index}`;
  const textProps = {
    x: '50%',
    y: '0.9em',
    textAnchor: 'middle',
    dominantBaseline: 'alphabetic',
    fontFamily: 'articulat-cf, sans-serif',
    fontWeight: 700,
    fontSize: '1em',
    style: { letterSpacing: '-0.03em' },
  };

  useEffect(() => {
    if (!isVisible) {
      setMotionDone(false);
      return;
    }
    if (reducedMotion) {
      setMotionDone(true);
    }
  }, [isVisible, reducedMotion]);

  let motionClass = 'skill-glass-title-motion--hidden';
  if (isVisible) {
    if (reducedMotion) {
      motionClass = 'skill-glass-title-motion--shown';
    } else if (fromLeft) {
      motionClass = 'skill-glass-title-motion--fly-left';
    } else {
      motionClass = 'skill-glass-title-motion--fly-right';
    }
  }

  const shellClass = [
    'skill-glass-title-shell',
    motionDone ? 'skill-glass-title-shell--motion-done' : '',
    darkWhenIdle ? 'skill-glass-title-shell--dark-idle' : '',
    isActive ? 'skill-glass-title-shell--active' : '',
  ]
    .filter(Boolean)
    .join(' ');

  const handleAnimationEnd = (event) => {
    if (event.animationName.startsWith('skill-glass-fly')) {
      setMotionDone(true);
    }
  };

  return (
    <div className={shellClass} style={{ fontSize: `${fontSizePx}px` }}>
      <div
        className={`skill-glass-title-motion ${motionClass}`}
        style={enterDelayMs > 0 ? { animationDelay: `${enterDelayMs}ms` } : undefined}
        onAnimationEnd={handleAnimationEnd}
      >
        <div className="skill-glass-title-clip">
          <div className="skill-glass-title-wrapper">
            <div
              className="skill-glass-title-blur"
              style={{
                clipPath: `url(#${clipId})`,
                WebkitClipPath: `url(#${clipId})`,
              }}
              aria-hidden="true"
            />
            <svg
              className="skill-glass-title-svg"
              aria-hidden="true"
              focusable="false"
            >
              <defs>
                <clipPath id={clipId}>
                  <text {...textProps}>{title}</text>
                </clipPath>
              </defs>
              <text {...textProps} className="skill-glass-title-fill-svg">
                {title}
              </text>
            </svg>
          </div>
        </div>
      </div>
      <h3 className="skill-glass-title-a11y">{title}</h3>
    </div>
  );
}
